import { useCallback, useMemo } from 'react';
import { post } from 'libs/fetch';

export const useEntry = () => {
  const createEntry = useCallback(async () => {
    const response = await post('api/v1/admin/sales_forces/entries', {})
    if (response.ok) {
      return { result: true }
    }

    return { result: false }
  }, []);

  return useMemo(() => ({ createEntry }),[ createEntry ])
}
